import { TimelineMax, Expo } from 'gsap';
import hades from '@/scripts/hades';
import utils from '@/scripts/utils';

export function menuOpen(el, last) {
  const offset = window.innerWidth < 768 ? 60 : 115;
  const top = window.innerWidth < 768 ? window.innerHeight / 3 : window.innerHeight / 4;

  const tl = new TimelineMax({
    paused: true,
  });

  let status = false;

  // const lines = Array.from(el.querySelectorAll('[data-view="true"] .line'));
  const others = Array.from(el.querySelectorAll('[data-view]'));
  const titles = Array.from(el.querySelectorAll('[data-nav]:not([data-project])'));

  const menu = document.querySelector('nav[role="menu"]');
  const voices = Array.from(document.querySelectorAll('nav[role="menu"] [data-nav]'));
  const voicesTitle = Array.from(document.querySelectorAll('nav[role="menu"] [data-nav] h2'));

  const footer = document.querySelector('footer');
  const info = document.querySelector('.footer__info');
  const aside = Array.from(document.querySelectorAll('aside'));

  const lang = document.querySelector('nav[role="menu"] .lang');
  const extra = document.querySelector('nav[role="menu"] .extra');
  const copyright = document.querySelector('nav[role="menu"] .copyright');
  const infoMobile = document.querySelector('nav[role="menu"] .info__menu');

  const infoEls = window.innerWidth >= 768 ? [...lang.children,...copyright.children, ...extra.children] : [...lang.children,...infoMobile.children];
  if (last.dataset.navproject === undefined) {
    titles.forEach((el) => { if(el.children[0].dataset.view === 'true') status = true });
  }
  const voicesSorted = status ? setNav(voices, last) : voices.reverse();

  tl
    .addLabel('start')
    .set(menu, {
      autoAlpha: 1,
      pointerEvents: 'auto',
    }, 'start')
    .set(titles, {
      autoAlpha: 0,
    }, 'start')
    .set(voices, {
      autoAlpha: 1,
      y: 0,
      pointerEvents: 'auto', 
    }, 'start')
    // .to(lines, 1.2, {
    //   autoAlpha: 0,
    //   ease: Expo.easeOut,
    // }, 'start')
    .to([others, footer, aside, info], 0.9, {
      autoAlpha: 0,
      rotationX: -12,
      ease: Expo.easeOut,
    }, 'start')
    .staggerTo(voicesSorted, 1.7, {
      top,
      cycle: {
        y: (i, el) => parseInt(el.dataset.order, 10) * offset,
      },
      ease: Expo.easeInOut,
    }, 0.08, 'start+=0.2')
    .to(voicesTitle, 1.2, {
      autoAlpha: 0.15,
      ease: Expo.easeOut,
    }, 'start')
    .to(voicesTitle, 1.7, {
      scaleY: 1,
      y: 0,
      ease: Expo.easeInOut,
    }, 'start+=0.2')
    .staggerTo(infoEls, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeInOut,
    }, 0.05, 'start+=0.2')

  return tl;
}

export function menuClose(el, last) {
  const tl = new TimelineMax();

  const others = Array.from(el.querySelectorAll('[data-view]'));
  const titles = Array.from(el.querySelectorAll('[data-nav]:not([data-project])'));
  const menu = document.querySelector('nav[role="menu"]');
  const voices = Array.from(document.querySelectorAll('nav[role="menu"] [data-nav]'));
  const voicesTitle = Array.from(document.querySelectorAll('nav[role="menu"] [data-nav] h2'));

  const footer = document.querySelector('footer');
  const info = document.querySelector('.footer__info');
  const aside = Array.from(document.querySelectorAll('aside'));

  const lang = document.querySelector('nav[role="menu"] .lang');
  const extra = document.querySelector('nav[role="menu"] .extra');
  const copyright = document.querySelector('nav[role="menu"] .copyright');
  const infoMobile = document.querySelector('nav[role="menu"] .info__menu');

  const infoEls = window.innerWidth >= 768 ? [...lang.children,...copyright.children, ...extra.children] : [...lang.children,...infoMobile.children];

  if (last.dataset.navproject === undefined) {
    titles.forEach((el) => { if(el.children[0].dataset.view === 'true') status = true });
  }

  const voicesSorted = status ? setNav(voices, last) : voices.reverse();

  tl
    .addLabel('start')
    .to(infoEls, 0.7, {
      autoAlpha: 0,
      y: 50,
      ease: Expo.easeOut,
    }, 'start')
    .staggerTo(voicesSorted, 1.7, {
      pointerEvents: 'none',
      y: 0,
      cycle: {
        top: (i, el) => parseInt(el.dataset.origin, 10),
      },
      ease: Expo.easeInOut,
    }, -0.08, 'start')
    .to(voicesTitle, 1.2, {
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 'start+=0.5')
    .addLabel('end')
    .to([others, footer, aside, info], 0.9, {
      autoAlpha: 1,
      rotationX: 0,
      ease: Expo.easeOut,
    }, 'end')
    .set(titles, {
      autoAlpha: 1,
    }, 'end+=1')
    .set(menu, {
      autoAlpha: 0,
      pointerEvents: 'none',
    }, 'end+=1');

    return tl;
}

export function menuIn(el, delay) {
  const tl = new TimelineMax({
    delay,
  });

  const menu = document.querySelector('nav[role="menu"]');

  const footer = document.querySelector('footer');
  const aside = Array.from(document.querySelectorAll('aside'));

  tl
    .addLabel('start')
    .set(el, {
      autoAlpha: 1,
    }, 'start')
    .to([footer, aside], 0.7, {
      autoAlpha: 1,
      rotationX: 0,
      ease: Expo.easeOut,
    }, 'start')
    .set(menu, {
      autoAlpha: 0,
      pointerEvents: 'none',
    });

  return tl;
}

export function menuOut(el, item, route) {
  // const scrollY = hades.ref.amount.y;
  const scrollY = hades.ref.amount.y;
  const tl = new TimelineMax();

  const title = document.querySelector(`main[js-page="${route}"] [data-nav="${route}"]`);
  const bounding = title.getBoundingClientRect();

  const menu = document.querySelector('nav[role="menu"]');
  const voicesPointers = Array.from(document.querySelectorAll(`nav[role="menu"] [data-nav]`));
  const voices = Array.from(document.querySelectorAll(`nav[role="menu"] [data-nav]:not([data-nav="${route}"])`));
  const voicesTitle = Array.from(document.querySelectorAll(`nav[role="menu"] [data-nav="${route}"] h2`));

  const lang = document.querySelector('nav[role="menu"] .lang');
  const extra = document.querySelector('nav[role="menu"] .extra');
  const copyright = document.querySelector('nav[role="menu"] .copyright');
  const infoMobile = document.querySelector('nav[role="menu"] .info__menu');

  const infoEls = window.innerWidth >= 768 ? [...lang.children,...copyright.children, ...extra.children] : [...lang.children,...infoMobile.children];

  tl
    .add('start')
    .set(voicesPointers, {
      pointerEvents: 'none',
    }, 'start')
    .staggerTo(voices, 1.7, {
      autoAlpha: 0,
      ease: Expo.easeOut,
      pointerEvents: 'none',
    }, -0.04, 'start')
    .to(voicesTitle, 1.2, {
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 'start')
    .to(infoEls, 0.7, {
      autoAlpha: 0,
      y: 50,
      ease: Expo.easeOut,
    }, 'start')
    .to(item, 1.5, {
      top: bounding.top + scrollY,
      left: bounding.left,
      y: 0,
      ease: Expo.easeInOut,
    }, 'start+=0.5');

  return tl;
}

export function menuLang(el) {
  const scrollY = hades.ref.amount.y;
  const tl = new TimelineMax();
  const menu = document.querySelector('nav[role="menu"]');

  const footer = document.querySelector('footer');
  const aside = Array.from(document.querySelectorAll('aside'));

  tl
    .add('start')
    .set(menu, {
      autoAlpha: 0,
    }, 'start')
    .to([footer, aside], 0.7, {
      autoAlpha: 1,
      rotationX: 0,
      ease: Expo.easeOut,
    }, 'start+=0.5');

  return tl;
}

export function menuHome(el) {
  const scrollY = hades.ref.amount.y;
  const tl = new TimelineMax();
  const menu = document.querySelector('nav[role="menu"]');

  const voices = Array.from(document.querySelectorAll('nav[role="menu"] [data-nav]'));

  const footer = document.querySelector('footer');
  const aside = Array.from(document.querySelectorAll('aside'));

  tl
    .add('start')
    .staggerTo(voices, 1, {
      pointerEvents: 'none',
      autoAlpha: 0,
      ease: Expo.easeInOut,
    }, -0.08, 'start')
    .to(menu, 0.75, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    }, 'start+=1')

  return tl;
}

export function menuInfo(el) {
  const tl = new TimelineMax();

  const lang = el.querySelector('.lang');
  const extra = el.querySelector('.extra');
  const copyright = el.querySelector('.copyright');
  const infoMobile = el.querySelector('.info__menu');

  const infoEls = [...lang.children,...infoMobile.children];
  const infoToggle = [...copyright.children, ...extra.children];

  tl
    .add('start')
    .set(infoToggle, {
      y: 0,
    }, 'start')
    .to(infoEls, 1, {
      // autoAlpha: 0,
      y: -50,
      ease: Expo.easeOut,
    }, 'start')
    .to(infoToggle, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    }, 'start+=0.5')

  return tl;
}


function setNav(voices, last) {
  const sorted = [];
  let index = null;

  const dataNav = last.dataset.nav;
  const voice = voices.filter(el => el.dataset.nav === dataNav);
  index = Array.from(voices).indexOf(voice[0]);

  if (index >= 0) sorted.push(voices[index]);

  const arrayBefore = voices.slice(0, index);
  const arrayAfter = voices.slice(index + 1, voices.length);

  const arrayMatch = arrayBefore.length > arrayAfter.length ? arrayBefore : arrayAfter;

  arrayMatch.forEach((el, i) => {
    const l = arrayBefore.length - 1;
    if (arrayBefore[l - i] !== undefined) sorted.push(arrayBefore[l - i]);
    if (arrayAfter[i] !== undefined) sorted.push(arrayAfter[i]);
  });

  return sorted;
}